import { createContext, useContext } from 'react';

export const OktaContext = createContext(null) as any;

export function useOktaReducer() {
    return useContext(OktaContext);
}